import Ajv from 'ajv';
import { schemas } from '@/utils/ajv/schemas';

class Validator {
  private static _instance: Ajv.Ajv;
  static instance(): Ajv.Ajv {
    return (this._instance ??= new Ajv({ schemas }));
  }

  static validate(key: string, data: any): void {
    const validate = Validator.instance().getSchema(key);
    if (!validate) throw `Scheme ${key} is not defined`;
    if (!validate(data)) validate.errors?.forEach(error => console.error(error));
  }
}

export { Validator };
